<aside
  class="relative h-screen-safe bg-white flex flex-col transition-all duration-300"
  [ngClass]="isCollapsed ? 'w-[80px]' : 'w-[272px]'"
>

  <!-- Logo -->
  <div
    class="h-20 border-b flex items-center transition-all"
    [ngClass]="{
      'justify-center px-2': isCollapsed,
      'justify-between px-4 md:justify-center md:px-9': !isCollapsed
    }"
  >
    <!-- Botão fechar mobile (apenas < md) -->
    <button 
      (click)="onCloseMobileSidebar()"
      class="md:hidden p-2 hover:bg-gray-100 rounded-lg"
    >
      <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M15.8333 5.34166L14.6583 4.16666L10 8.825L5.34166 4.16666L4.16666 5.34166L8.825 10L4.16666 14.6583L5.34166 15.8333L10 11.175L14.6583 15.8333L15.8333 14.6583L11.175 10L15.8333 5.34166Z"/>
      </svg>
    </button>
    
    <!-- Logo clicável -->
    <a routerLink="/main/v2" class="cursor-pointer">
      <img
        *ngIf="!isCollapsed"
        src="assets/icons/logo-v2.svg"
        class="h-8 max-w-[200px] object-contain"
      />
      <img
        *ngIf="isCollapsed"
        src="assets/icons/mini-logo-v2.svg"
        class="h-9 w-9 object-contain"
      />
    </a>
    
    <!-- Spacer para centralizar logo em mobile -->
    <div class="md:hidden w-9"></div>
  </div>

  <!-- Dropdown de módulo como primeiro item do menu -->
  <div *ngIf="!isCollapsed && modules.length > 1" class="px-5 pt-4 pb-2">
    <div class="relative" >
      <!-- Custom dropdown button -->
      <button
        type="button"
        (click)="toggleModuleDropdown()"
        class="w-full flex items-center justify-between px-[12px] py-[10px] rounded-[10px] border border-westetics-purple-800 text-xs text-westetics-neutral-800 bg-white hover:bg-westetics-neutral-50"
        aria-haspopup="listbox"
        [attr.aria-expanded]="moduleDropdownOpen"
      >
  <span class="truncate text-left">{{ selectedModule.description }}</span>
        <!-- arrow -->
        <svg class="ml-2 w-4 h-4 text-westetics-gray-600" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M9.99956 10.879L13.7121 7.1665L14.7726 8.227L9.99956 13L5.22656 8.227L6.28706 7.1665L9.99956 10.879Z" fill="#99A0AE"/>
        </svg>
      </button>

      <!-- Options panel -->
      <ul *ngIf="moduleDropdownOpen" role="listbox" class="absolute z-50 left-0 mt-2 w-full bg-white border rounded-lg shadow-lg max-h-56 overflow-auto py-1">
        <li *ngFor="let m of modules" role="option" (click)="selectModule(m)" class="px-3 py-2 cursor-pointer hover:bg-westetics-purple-600 hover:text-westetics-white text-sm flex items-center gap-2"
          [ngClass]="{ 'bg-westetics-purple-600 text-westetics-white': selectedModule.id === m.id }">
          <span class="truncate">{{ m.description }}</span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Sections -->
  <ng-container *ngFor="let section of menu">

    <nav
      *ngIf="hasVisibleItems(section)"
      class="flex flex-col p-5 gap-1 transition-all"
      [ngClass]="{
        'items-center': isCollapsed,
        'items-start': !isCollapsed
      }"
    >

      <!-- Section title -->
      <p
        class="uppercase font-sans text-xs font-medium text-westetics-neutral-600 mb-1 tracking-wider"
      >
        {{ isCollapsed ? section.titleMini : section.title }}
      </p>


      <!-- Items -->
      <ng-container *ngFor="let item of section.items">
        <a
          *ngIf="canViewMenuItem(item.label, item.route)"
          [routerLink]="getItemRoute(item.label, item.route)"
          (click)="onCloseMobileSidebar()"
          class="group relative flex items-center w-full gap-3 px-4 py-2 rounded-lg
                text-westetics-neutral-800
                hover:bg-westetics-purple-600
                hover:text-westetics-white
                transition"
          [ngClass]="{
            'justify-center px-0': isCollapsed,
            'justify-start': !isCollapsed,
            'bg-westetics-purple-600 text-westetics-white': isRouteActive(getItemRoute(item.label, item.route))
          }"
        >
         <span
            class="absolute -left-5 top-1/2 -translate-y-1/2 h-5 w-1 rounded-r bg-westetics-purple-600 opacity-0 transition"
            [class.opacity-100]="isRouteActive(getItemRoute(item.label, item.route))"
          ></span>

      <app-icon
        [name]="item.icon"
        class="w-5 h-5 text-westetics-neutral-800 group-hover:text-westetics-white self-center"
        [ngClass]="{ 'text-westetics-white': isRouteActive(getItemRoute(item.label, item.route)) }"
      ></app-icon>

          <span
    *ngIf="!isCollapsed"
    class="font-sans text-sm font-medium leading-5 self-center"
  >
    {{ getItemLabel(item.label) }}
  </span>

      <!-- Arrow icon on the right side (rotated to point right) -->
      <svg
        *ngIf="!isCollapsed"
        class="absolute right-3 top-[48%] -translate-y-1/2 -rotate-90
              w-4 h-4 text-westetics-neutral-800
              group-hover:text-westetics-white
              pointer-events-none"
        [ngClass]="{ 'text-westetics-white': isRouteActive(getItemRoute(item.label, item.route)) }"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M9.99956 10.879L13.7121 7.1665L14.7726 8.227L9.99956 13L5.22656 8.227L6.28706 7.1665L9.99956 10.879Z" />
      </svg>

        </a>
      </ng-container>

    </nav>

  </ng-container>

  <!-- Seletor de clínica ativa (posicionado acima do rodapé do usuário) -->
  <div *ngIf="!isCollapsed" class="mt-auto px-4 pb-3">
    <app-clinic-switcher></app-clinic-switcher>
  </div>
  <!-- Spacer para empurrar rodapé quando sidebar está recolhida -->
  <div *ngIf="isCollapsed" class="mt-auto"></div>

  <div
  class="flex items-center px-4 py-4 border-t transition-all safe-area-bottom"
  [ngClass]="{
    'justify-center': isCollapsed,
    'gap-2': !isCollapsed
  }"
>
 
  <!-- Infos do usuário (somem quando recolhido) -->
  <div
    *ngIf="!isCollapsed"
    class="flex-1 min-w-0"
  >
    <p class="truncate">{{ username }}</p>
    <p class="truncate text-sm text-westetics-neutral-600">
      {{ companyName }}
    </p>
  </div>

  <button (click)="toggleSidebar()" class="absolute bottom-[72px] left-full -ml-3 mb-10 w-6 h-6 p-0.5 hidden md:flex items-center justify-center rounded-md bg-westetics-purple-800 hover:bg-westetics-neutral-800 transition" > <svg class="w-4 h-4 transition-transform duration-300" [class.rotate-180]="isCollapsed" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" > <path d="M9.2045 10.0007L12.917 6.28818L11.8565 5.22768L7.0835 10.0007L11.8565 14.7737L12.917 13.7132L9.2045 10.0007Z" fill="white" /> </svg> </button>

  <!-- Botão logout (some quando recolhido) -->
  <button
    class="flex items-center justify-center bg-westetics-purple-800 hover:bg-westetics-purple-600 w-10 h-10 rounded-lg text-xs text-white"
    (click)="logout()"
  >
    <p>Sair</p>
  </button>
</div>


</aside>
